import * as yup from 'yup';

import { IS_REQUIRED, isGreaterThanOrEqualTo } from '@occc-app/lib/constants/validationMessages';

export const progressPerTransactionSchema = yup
  .object()
  .shape({
    isEnabled: yup.boolean(),
    limit: yup.number().when('isEnabled', {
      is: true,
      then: () => yup.number().min(1, isGreaterThanOrEqualTo(1)).required(IS_REQUIRED),
    }),
  })
  .optional();
